import {useAppState} from '../state'

export const IsUserHealthInspector = () => {
  const {state} = useAppState()
  const isHealthInspector = Boolean(
    state?.me?.user?.highestRole === 'HI' ||
      state?.me?.user?.userToSite?.some((uts: any) => uts && uts.userRole === 'HI')
  )

  return {isHealthInspector}
}

export default IsUserHealthInspector
